import styled from 'styled-components';
import { rgba } from 'polished';
import { sectionWidth } from 'styles/spacings';
import { slideIn } from 'styles/animation';
import { colors } from '@alixpartners/ui-components';

export const Wrapper = styled.section`
	display: flex;
	flex-direction: column;
	background-color: white;
	max-width: ${sectionWidth};
	min-width: ${sectionWidth};
	width: 100%;
	padding-top: 32px;
	box-shadow: 0 3px 10px 0 ${rgba('#000', 0.1)};
	animation-name: ${slideIn};
	animation-duration: 600ms;
	animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);

	&:first-child {
		margin-top: 0;
	}
`;

export const Container = styled.div`
	padding: 0 32px 24px 32px;
`;

export const Title = styled.span`
	display: block;
	width: 100%;
	font-weight: 500;
	font-size: 23px;
	line-height: 31px;
	letter-spacing: 0.3px;
	color: ${colors.grey7};
	padding-bottom: 12px;
`;

export const Table = styled.div`
	width: 100%;
	padding: 2% 0;
`;

export const Actions = styled.div`
	width: 100%;
	display: flex;
	justify-content: ${props => (props.isTree ? 'space-between' : 'flex-end')};
`;

export const AbortPopup = styled.div`
	pointer-events: none;
`;

export const ModalBody = styled.div`
	text-align: center;
	margin: 2px;
`;
